import {QueryParamsEnum} from 'presentation/constants';
import {useQueryParams} from 'presentation/pages';
import {useBookingStore} from '../../store/useBookingStore';
import {TypeLocalNameEnum} from 'domain/usecases';
import {ResetBookingFlowProps} from './types';

export function useResetBookingFlow() {
	const setBookingData = useBookingStore(state => state.setBookingData);
	const {setSearchParams} = useQueryParams();

	const resetBookingFlow = ({
		keepGeolocationInfo,
		keepTypeLocalName,
		keepAdvanceDiagnosticsContext,
	}: ResetBookingFlowProps = {}) => {
		setBookingData(prev => {
			if (keepAdvanceDiagnosticsContext) {
				return {
					...prev,
					specialtyCode: '',
					specialtyName: '',
					subSpecialtyCode: '',
					procedureCode: '',
					professionalCode: '',
					professionalName: '',
					dateAt: '',
					hourAt: '',
				};
			}

			return {
				...prev,
				unitCode: '',
				unitName: '',
				unitAddress: '',
				professionalCode: '',
				professionalName: '',
				dateAt: '',
				hourAt: '',
				specialtyCode: '',
				specialtyName: '',
				subSpecialtyCode: '',
				districtName: '',
				odontoRecommendations: '',
				allDistrictsSelected: false,
				citiesNames: '',
				coordinates: keepGeolocationInfo ? prev.coordinates : '',
				isManualLocation: keepGeolocationInfo ? prev.isManualLocation : true,
				hasGeoDistrictsFilter: false,
				odontoUnitDistrictSelected: '',
				typeLocalName: keepTypeLocalName ? prev.typeLocalName : TypeLocalNameEnum.CIDADE,
				initialBookingLocationData: undefined,
				isFavoriteDoctorsFlow: false,
				isAdvanceDiagnosticsFlow: false,
			};
		});

		setSearchParams(
			prev => {
				prev.delete(QueryParamsEnum.SHIFT);
				prev.delete(QueryParamsEnum.SEARCH_QUERY);
				prev.delete(QueryParamsEnum.DISABILITY);
				prev.delete(QueryParamsEnum.INCLUDE_NEIGHBORHOOD);
				prev.delete(QueryParamsEnum.LOCALITY_DISTANCE);
				prev.delete(QueryParamsEnum.AUTOCOMPLETE_QUERY);

				if (keepAdvanceDiagnosticsContext) {
					prev.delete(QueryParamsEnum.SPECIALTY_NAME);
					prev.delete(QueryParamsEnum.PROCEDURE);
				}

				return prev;
			},
			{
				replace: true,
			},
		);
	};

	return {resetBookingFlow};
}
